"use strict";

const Endpoint = {
  // GLOBAL
  GET_LIST_NEGARA: "gis/listnegara",
  GET_LIST_MASTER_DATA: "masterData/list",
  GET_LIST_ICD: "icd/listICD",

  // MODULE RESERVASI DASHBOARD
  MODULE_DASHBOARD_LIST_RESERVASI_POST: "reservasi/listReservasi",
  MODULE_DASHBOARD_ACCEPT_POST: "reservasi/acceptReservasi",

  MODULE_DASHBARD_DOKTER_LIST_KONSULTASI_POST: "reservasi/listKonsultasi",

  MODULE_DASHBARD_APOTEK_LIST_RESERVASI_RESEP_OBAT_POST: "reservasi/listReservasiResepObat",
  MODULE_DASHBARD_APOTEK_DETAIL_RESERVASI_RESEP_OBAT_POST: "reservasi/detailResepObat",
  MODULE_DASHBARD_APOTEK_FINISH_RESEP_OBAT: "reservasi/finishResepObat",

  // MODULE PASIEN
  MODULE_PASIEN_CREATE_POST: "pasien/daftarPasien",
  MODULE_PASIEN_UPDATE_POST: "pasien/updatePasien",
  MODULE_PASIEN_DETAIL_GET: "pasien/listPasien?id=",
  MODULE_PASIEN_VALIDATE_CODE_GET: "pasien/validatePasienCode?id=",
  MODULE_PASIEN_LIST_GET: "pasien/listPasien",

  // MODULE LAYANAN
  MODULE_LAYANAN_CREATE_POST: "layanan/saveLayanan",
  MODULE_LAYANAN_UPDATE_POST: "layanan/updateDataLayanan",
  MODULE_LAYANAN_DETAIL_GET: "layanan/listLayanan?detail=",
  MODULE_LAYANAN_LIST_GET: "layanan/listLayanan?id=",
  MODULE_LAYANAN_DROPDOWN_LIST_POST: "layanan/dropdownListLayanan",
  MODULE_LAYANAN_DROPDOWN_DETAIL_GET: "layanan/detailLayanan?id=",

  // MODULE_LAYANAN_DEL: "Layanan/ListLayanan?id=",

  // MOULE POLI
  MODULE_POLI_DETAIL_GET: "poli/listpoli?detail=",
  MODULE_POLI_LIST_GET: "poli/listpoli?id=",
  MODULE_POLI_CREATE_POST: "poli/savePoli",
  MODULE_POLI_UPDATE_POST: "poli/updateDataPoli",

  // MODULE OBAT
  MODULE_OBAT_DETAIL_GET: "obat/listobat?detail=",
  MODULE_OBAT_LIST_GET: "obat/listobat?id=",
  MODULE_OBAT_CREATE_POST: "obat/saveObat",
  MODULE_OBAT_UPDATE_POST: "obat/updateDataObat",
  MODULE_OBAT_MASUK_LIST_GET: "obat/listObatMasuk?id=",
  MODULE_OBAT_MASUK_CREATE_POST: "obat/saveObatMasuk",
  MODULE_OBAT_KELUAR_LIST_GET: "obat/listObatKeluar?id=",
  MODULE_OBAT_DROPDOWN_LIST_POST: "obat/dropdownListObat",
  MODULE_OBAT_DROPDOWN_DETAIL_GET: "obat/detailObat?id=",

  // MODULE DOKTER
  MODULE_DOKTER_DETAIL_GET: "dokter/listdokter?",
  MODULE_DOKTER_LIST_GET: "dokter/listdokter",
  MODULE_DOKTER_CREATE_POST: "dokter/daftarDokter",
  MODULE_DOKTER_UPDATE_POST: "dokter/updateDataDokter",
  MODULE_DOKTER_CREATE_DOKTER_PRAKTEK_POST: "dokter/tambahDokterPraktek",
  MODULE_DOKTER_CREATE_JADWAL_PRAKTEK_POST: "dokter/tambahJadwalPraktek",
  MODULE_DOKTER_LIST_DOKTER_PRAKTEK_GET: "dokter/listDokterPraktek?id=",
  MODULE_DOKTER_CHECK_DOKTER_PRAKTEK_POST: "dokter/isDokterPraktekExist",
  MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_POST: "dokter/checkStatusDiagnosa",
  MODULE_DOKTER_DIAGNOSA1_POST: "dokter/diagnosaPasien1",
  MODULE_DOKTER_DIAGNOSA2_POST: "dokter/diagnosaPasien2",
  MODULE_DOKTER_DIAGNOSA3_POST: "dokter/diagnosaPasien3",
  MODULE_DOKTER_SUBMIT_DIAGNOSA1_POST: "dokter/submitDiagnosaPasien1",
  MODULE_DOKTER_SUBMIT_DIAGNOSA3_POST: "dokter/submitDiagnosaPasien3",
  MODULE_DOKTER_SUBMIT_DIAGNOSA4_POST: "dokter/submitDiagnosaPasien4",

  // MODULE RESERVASI
  MODULE_RESERVASI_CREATE_POST: "reservasi/createReservasi",

  // MODULE KASIR
  MODULE_KASIR_DETAIL_POST: "kasir/listTransaksiPasien",
  MODULE_KASIR_LIST_POST: "kasir/listTransaksiPasien",
  MODULE_KASIR_SUBMIT_PEMBAYARAN_PASIEN: "kasir/submitPembayaranPasien",
  MODULE_KASIR_PEMASUKAN_HARIAN_POST: "kasir/pemasukanHarian",

  // MODULE USER MEDIS
  MODULE_USERMEDIS_DETAIL_POST: "userMedis/listUserMedis",
  MODULE_USERMEDIS_LIST_POST: "userMedis/listUserMedis",
  MODULE_USERMEDIS_SUBMIT_USERMEDIS: "userMedis/saveUserMedis",

  // AUTH
  MODULE_AUTH_CHECK_USER_LOGIN: "auth/getUserInfo",
  MODULE_AUTH_REGISTER_MASTER_KLINIK: "auth/registerMasterKlinik",
  MODULE_AUTH_REGISTER_DATA_KLINIK: "auth/registerDataKlinik",
  MODULE_AUTH_VERIFIKASI_PASSWORD: "auth/verifikasiPassword",
  MODULE_AUTH_CHECK_URL_POST: "auth/checkDirectURL",

  // MODULE REKAM MEDIS
  MODULE_REKAMMEDIS_DETAIL_POST: "rekamMedis/listRekamMedis",
  MODULE_REKAMMEDIS_LIST_POST: "rekamMedis/listRekamMedis",
  MODULE_REKAMMEDIS_RIWAYAT_PENYAKIT_PASIEN_POST: "rekamMedis/riwayatPenyakitPasien",

  // MODULE REPORT
  MODULE_REPORT_LIST_ICD_PASIEN_POST: "report/monthReportICD",
  MODULE_REPORT_LIST_KUNJUNGAN_PASIEN_POST: "report/reportKunjunganPasien",
};

export default Endpoint;
